import {
  GET_HOME_PROFILE_REQUEST,
  GET_HOME_PROFILE_RESPONSE,
  GET_HOME_PROFILE_ERROR,
} from 'actions/homepage';
import { GET_HOME_PREVIOUS_BASKET_RESPONSE } from 'actions/previousBaskets';
import {
  SHOW_PROMOTION_MEAL_DETAILS,
  HIDE_PROMOTION_MEAL_DETAILS,
  SHOW_PROMOTION_CONFIRMATION_MODAL,
  HIDE_PROMOTION_CONFIRMATION_MODAL,
} from 'actions/promotionMealDetails';
import { GET_HOME_REVIEWABLE_MEALS_RESPONSE } from 'actions/reviewableMeals';
import {
  ADD_REVIEW_RESPONSE,
  REVIEW_CHANGE,
  UPDATE_REVIEW_RESPONSE,
  UPDATE_REVIEW_FOR_COOKBOOK_RESPONSE,
} from 'actions/reviews';
import { GET_USER_RESPONSE } from 'actions/user';
import { transformReviewableMealReviews } from 'services/RequestService/helpers';

const initialState = {
  currentMenu: {},
  isLoading: false,
  previousBaskets: [],
  previousMenu: {},
  reviewableMeals: [],
  sections: [],
  promotionMealDetails: {
    shouldDisplay: false,
    mealId: null,
    menuSlug: null,
    shouldDisplayConfirmationModal: false,
    actionType: null,
    heading: null,
    zone: null,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_HOME_PROFILE_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case GET_HOME_PROFILE_RESPONSE:
      return {
        ...state,
        sections: action.response.sections,
        currentMenu: action.response.currentMenu,
        previousMenu: action.response.previousMenu,
        isLoading: false,
      };
    case GET_HOME_PROFILE_ERROR:
      return {
        ...state,
        isLoading: false,
      };
    case GET_USER_RESPONSE:
      return {
        ...state,
      };
    case GET_HOME_PREVIOUS_BASKET_RESPONSE:
      return {
        ...state,
        previousBaskets: action.response.previousBaskets || [],
      };
    case GET_HOME_REVIEWABLE_MEALS_RESPONSE:
      return {
        ...state,
        reviewableMeals: action.response.reviewableMeals || [],
      };
    case REVIEW_CHANGE:
      return {
        ...state,
        reviewableMeals: state.reviewableMeals.map(reviewableMeal =>
          reviewableMeal.mealId === action.mealId
            ? {
                ...reviewableMeal,
                review: {
                  ...reviewableMeal.review,
                  pendingChanges: { recipeRating: action.review.recipeRating },
                },
              }
            : reviewableMeal
        ),
      };
    case ADD_REVIEW_RESPONSE:
    case UPDATE_REVIEW_RESPONSE:
    case UPDATE_REVIEW_FOR_COOKBOOK_RESPONSE:
      return transformReviewableMealReviews(state, action.response);
    case SHOW_PROMOTION_MEAL_DETAILS:
      return {
        ...state,
        promotionMealDetails: {
          shouldDisplay: true,
          mealId: action.mealId,
          menuSlug: action.menuSlug,
          heading: action.heading,
          zone: action.zone,
        },
      };
    case HIDE_PROMOTION_MEAL_DETAILS:
      return {
        ...state,
        promotionMealDetails: {
          shouldDisplay: false,
          mealId: null,
          menuSlug: null,
          shouldDisplayConfirmationModal: false,
          heading: null,
          zone: null,
        },
      };
    case SHOW_PROMOTION_CONFIRMATION_MODAL:
      return {
        ...state,
        promotionMealDetails: {
          ...state.promotionMealDetails,
          menuSlug: action.menuSlug,
          shouldDisplayConfirmationModal: true,
          actionType: action.actionType,
          mealId: action.mealId,
        },
      };
    case HIDE_PROMOTION_CONFIRMATION_MODAL:
      return {
        ...state,
        promotionMealDetails: {
          ...state.promotionMealDetails,
          shouldDisplayConfirmationModal: false,
          actionType: null,
          menuSlug: null,
          mealId: null,
        },
      };
    default:
      return state;
  }
};

const selectHomepage = state => state.homepage;

export const selectCurrentMenuSlug = state => selectHomepage(state).currentMenu?.slug;
export const selectPreviousBaskets = state => selectHomepage(state).previousBaskets;
export const selectSections = state => selectHomepage(state).sections;
export const selectReviewableMeals = state => selectHomepage(state).reviewableMeals;
export const selectReviewableMeal = (state, mealId) =>
  selectReviewableMeals(state).find(meal => meal.mealId === mealId);
export const selectReviewableMealReview = (state, mealId) =>
  selectReviewableMeal(state, mealId)?.review;

export const selectPromotionMealDetails = state => selectHomepage(state).promotionMealDetails;
